import HeaderContainer from '../Header/Header-Container'
import Main from '../Main/Main'


const GranKushApp = ({user}) => {
    
    return(
        <div className="App">
             <HeaderContainer />
             <Main user={user}/>
        </div>
    )
}
export default GranKushApp 